import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSection from 'eco-design/base/eco-section';
import EcoImg from 'eco-design/base/eco-img';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.ModuleA');

    return (
        <div className={styles.comp} id="ModuleA">
          <EcoSpace />
          <EcoSection
            title={t('title')}
            desc={t('desc')}
          />
          <EcoSpaceSmall />
          <EcoImg
            pc="https://websiteoss.ecoflow.com/upload/image/1745459076561/MA.jpg"
            pad="https://websiteoss.ecoflow.com/upload/image/1745459076561/MA.jpg"
            h5="https://websiteoss.ecoflow.com/upload/image/1745459076198/MA-h5.jpg"
          />
          <EcoSpace />
        </div>
    );
}